import { appSelectors } from '@appStore/reducers/app'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { teamHooks } from 'features/team'
import { workspaceApi } from 'features/workspace'
import { useAppSelector } from 'shared/hooks'
import { useSubscriptionActive } from '../../hooks/useIsAvailable'
import { Mailbox } from '../Mailbox/Mailbox'
import {
	LinkedInMemberIssue,
	ProxyIssue,
	RemoteAutomationUnavailable,
	UnavailableSubscription
} from './Unavailable'

export function AvailabilityCheck() {
	const isReady = teamHooks.useParamPerson()
	if (!isReady) {
		return
	}

	return <SubscriptionCheck />
}

function SubscriptionCheck() {
	const isActive = useSubscriptionActive()
	return isActive ? <LinkedinInCheck /> : <UnavailableSubscription />
}

function LinkedinInCheck() {
	const isOpsSession = useAppSelector(appSelectors.appProfile)?.isOpsSession
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)
	const hasBackendAutomation = useAppSelector(appSelectors.isBackendAutomation)
	if ((isOpsSession || isImpersonated) && !hasBackendAutomation) {
		const result = <RemoteAutomationUnavailable />
		return result
	}

	const result = <CheckAutomationMode />
	return result
}

function CheckAutomationMode() {
	const hasBackendAutomation = useAppSelector(appSelectors.isBackendAutomation)
	const {
		data: autoMode,
		isFetching,
		isSuccess
	} = workspaceApi.useAutomationModeQuery()

	if (isFetching || !isSuccess) {
		const result = <FullLoader size={60} />
		return result
	}

	if (hasBackendAutomation && !autoMode.is_proxy_available) {
		const result = <ProxyIssue />
		return result
	}

	if (autoMode.is_signed_in_at_linkedIn === false) {
		const result = <LinkedInMemberIssue />
		return result
	}

	if (autoMode.is_signed_in_at_linkedIn === true) {
		const result = <Mailbox />
		return result
	}

	const result = <FullLoader size={60} />
	return result
}
